// extracted by mini-css-extract-plugin
export default {"loadingCover":"loadingCover___MmTEl","loadingCover_content":"loadingCover_content___zBIHv","loadingCover_message":"loadingCover_message___xqHY0"};